import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl } from "./services";
import { useNavigate } from "react-router-dom";

const MyPlans = () => {
  const navigate = useNavigate();

  const [JobData, setJobData] = useState([]);

  const UserID = localStorage.getItem("UserID");

  const ActiveJobs = async () => {
    await axios({
      method: "GET",
      url: MyApiUrl + "GetUserActiveJobs/" + UserID + "",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((response) => {
        setJobData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const StartTask = (JobID) => {
    localStorage.setItem("StartTaskJobID", JobID);
    navigate("/StartTask");
  };

  React.useEffect(() => {
    ActiveJobs();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <section className="content-inner overflow-hidden">
          <div className="container">
            <div
              className="section-head text-center"
              style={{ marginTop: "10%" }}
            >
              <h5
                className="sub-title wow fadeInUp"
                data-wow-delay="0.2s"
                style={{ fontSize: "20px", paddingBottom: "5%" }}
              >
                YOur Active Jobs / Plans
              </h5>
              <h2 className="title wow fadeInUp" data-wow-delay="0.4s">
                Find your active jobs below
              </h2>
            </div>
            <div className="row justify-content-center">
              {JobData.map((item) => {
                return (
                  <div className="col-lg-4 col-md-6 m-b30">
                    <div className="pricingtable-wrapper box-hover style-1 hover-aware">
                      <div className="pricingtable-inner">
                        <div className="pricingtable-title">
                          <h3 className="title">{item.job_name}</h3>
                        </div>
                        <div className="pricingtable-price">
                          <h2 className="pricingtable-bx text-secondary">
                            ₹ {item.job_price}
                            <small></small>
                          </h2>
                        </div>
                        <ul className="pricingtable-features">
                          <li>Daily Earning: {item.job_daily_earning}</li>
                          <li>No Of Task Per Day: {item.job_per_day_task}</li>
                          <li>Earning Per Task: {item.job_price_per_task}</li>
                        </ul>
                        <div className="pricingtable-footer">
                          <p
                            style={{
                              background: "#08cf33",
                              color: "#1c1c1c",
                              fontWeight: "700",
                              border: "1px solid #9f9f9f",
                              borderRadius: "5px",
                              padding: "4%",
                              fontSize: "18px",
                              marginBottom: "0",
                            }}
                          >
                            Active Job
                          </p>
                        </div>
                        <div className="pricingtable-footer">
                          <button
                            className="btn btn-outline-info"
                            style={{
                              fontSize: "18px",
                              width: "100%",
                            }}
                            onClick={() => {
                              StartTask(item.job_pkid);
                            }}
                          >
                            Start Task
                          </button>
                        </div>
                      </div>
                      <div className="effect bg-primary"></div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default MyPlans;
